import { GridConfiguration, GridConfigurationParams } from './types';
import {
  DEFAULT_CONTAINER_WIDTH,
  DEFAULT_BREAKPOINTS,
  DEFAULT_SPACING,
} from './constants';

export const getCurrentBreakpoint = (breakpoints, containerWidth) => {
  for (let i = 0; i < breakpoints.length; i++) {
    if (breakpoints[i].maxWidth >= containerWidth) return breakpoints[i];
  }
  return breakpoints[breakpoints.length - 1];
};

export const getGridConfiguration = ({
  breakpoints = DEFAULT_BREAKPOINTS,
  screenWidth = DEFAULT_CONTAINER_WIDTH,
  breakByScreenWidth = true,
  containerWidth = DEFAULT_CONTAINER_WIDTH,
  elementSpacing = DEFAULT_SPACING,
  preserveAspectRatio,
}: GridConfigurationParams): GridConfiguration => {
  const {
    elementWidth,
    elementHeight,
    elementsPerRow: elementsPerRowConfig,
    elementAspectRatio,
  } = getCurrentBreakpoint(
    breakpoints,
    breakByScreenWidth ? screenWidth : containerWidth
  );
  // We try to place X elements per row such that width of elements is as close
  // to targetWidth as possible, but not greater
  const elementsPerRow =
    elementsPerRowConfig ??
    Math.max(
      1,
      Math.floor(
        (containerWidth + elementSpacing) / (elementWidth! + elementSpacing)
      )
    );

  const ratio =
    elementAspectRatio ??
    (elementWidth && elementHeight ? elementWidth / elementHeight : 0);
  const adjustedElementWidth =
    (containerWidth + elementSpacing) / elementsPerRow - elementSpacing;
  const adjustedElementHeight = adjustedElementWidth / ratio;

  return {
    elementWidth: adjustedElementWidth,
    elementHeight: preserveAspectRatio ? adjustedElementHeight : elementHeight,
    elementSpacing,
    elementsPerRow,
  };
};
